import { render, staticRenderFns } from "./TagsItem.vue?vue&type=template&id=5d47f3e8&scoped=true&"
import script from "./TagsItem.vue?vue&type=script&lang=js&"
export * from "./TagsItem.vue?vue&type=script&lang=js&"
import style0 from "./TagsItem.vue?vue&type=style&index=0&id=5d47f3e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d47f3e8",
  null
  
)

export default component.exports